import Vue from 'vue';
import axios from 'axios';
import config from '../config/config';
import { joinApiUrl } from '../config/api-url';

const empty = () => ({ Ready: false, SystemAdmin: false, CommunityAdmin: false, MasterDataRead: false, BillingView: false,
  FormView: false, FormPreview: false, FormConfigure: false, PaymentConfigure: false, PaymentReason: null });
export const managementAccess = Vue.observable(empty());
let pending;
export async function loadManagementAccess(force = false) {
  if (pending && !force) return pending;
  if (managementAccess.Ready && !force) return managementAccess;
  Object.assign(managementAccess, empty());
  pending = axios.get(joinApiUrl(config.API_URL, 'api/permission-management/runtime'))
    .then(response => { Object.assign(managementAccess, response.data, { Ready: true }); return managementAccess; })
    .catch(() => managementAccess)
    .finally(() => { pending = null; });
  return pending;
}
export function canUseManagement(key) { return managementAccess.Ready && managementAccess[key] === true; }
export function filterManagementNavigation(items, roles) {
  const admin = (roles || []).includes('SYSTEM_ADMIN');
  return (items || []).filter(item => admin || !/^Systemeinstellungen.*Admin/i.test(String(item.title || '')))
    .map(item => ({ ...item, ...(Array.isArray(item.Children) ? { Children: filterManagementNavigation(item.Children, roles) } : {}) }));
}
const message = 'Diese Funktion steht Ihnen nicht zur Verfügung, da Ihnen die erforderliche Berechtigung fehlt.';
export function applyManagementDefinition(definition, name, access = managementAccess) {
  if (access.SystemAdmin) return definition;
  if (/^Systemeinstellungen.*Admin/i.test(name || '')) return { components: [{ type: 'content', key: 'accessDenied', html: '<p>' + message + '</p>' }] };
  if (name === 'Stammdaten' && !access.MasterDataRead) return { components: [{ type: 'content', key: 'masterDataDenied',
    html: '<div class="alert alert-info">Sie haben keine Berechtigung, die Stammdaten dieser Gemeinde einzusehen oder zu bearbeiten.</div>' }] };
  if (name === 'Systemeinstellungen') {
    function walk(nodes) {
      if (!Array.isArray(nodes)) return;
      nodes.forEach(node => {
        if (['paketeVerwalten', 'berechtigungenVerwalten', 'benutzerverwaltung'].includes(node.key) && !access.CommunityAdmin) node.hidden = true;
        if (node.key === 'rechnungsverwaltung' && !access.BillingView) node.hidden = true;
        if (node.key === 'formulareVerwalten' && !access.FormView) node.hidden = true;
        if (String(node.type || '').toLowerCase() === 'apieditgrid' && !access.CommunityAdmin) {
          node.allowAdd = false; node.allowEdit = false; node.allowDelete = false;
          node.rowActions = (node.rowActions || []).map(action => {
            const allowed = access.BillingView && String(action.method || '').toUpperCase() === 'GET'
              && String(action.endpoint || '').startsWith('/api/billing/invoices/');
            return { ...action, disabled: !allowed, tooltip: allowed ? action.tooltip : message };
          });
        }
        walk(node.components);
      });
    }
    walk(definition.components);
    if (!access.CommunityAdmin && !access.FormView && !access.BillingView) return { components: [{ type: 'content', key: 'settingsDenied',
      html: '<div class="alert alert-info">' + message + '</div>' }] };
  }
  return definition;
}
window.OzgPermissions = managementAccess;
window.OzgPermissionsLoad = loadManagementAccess;

export function prepareMasterDataSubmission(data, permissions, admin = false, communityAdmin = false) {
  const copy = JSON.parse(JSON.stringify(data || {}));
  if (admin) return copy;
  const levels = {};
  (permissions || []).filter(p => /^stammdaten\./i.test(p.permissionKey || '')).forEach(p => {
    const key = String(p.componentKey || '').toLowerCase();
    const level = Number(p.effectivePermissionLevel) || 0;
    levels[key] = levels[key] === undefined ? level : Math.min(levels[key], level);
  });
  function prune(node, root = false) {
    if (Array.isArray(node)) { node.forEach(child => prune(child)); return; }
    if (!node || typeof node !== 'object') return;
    Object.keys(node).forEach(key => {
      const level = levels[key.toLowerCase()];
      if ((root && level === undefined && !communityAdmin) || (level !== undefined && level < 2)) delete node[key];
      else prune(node[key]);
    });
  }
  prune(copy, true);
  return copy;
}
